// extracted by mini-css-extract-plugin
export var dateLabel = "_2g-0";
export var dateLabelError = "_2g-1";
export var fullWidth = "_2g-2";
export var smaller = "_2g-3";